import { blueprints } from '../blueprints/blueprints-sidecar'
import { asteroids } from '../entities/asteroids-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { machines } from '../machines/machines-sidecar'
import { scene } from '../main/scene-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { uiSpeedBar } from '../ui/uiSpeedBar-sidecar'
import { createTestRig_food } from './testRig_food'
import { settings } from '../engine/settings-sidecar'
import { createTestRig_water } from './testRig_water'
import { createTestRig_sleep } from './testRig_sleep'
import { createTestRig_mineAsteroid } from './testRig_mineAsteroid'
import { jobs } from '../behavior/jobs-sidecar'
import { createTestRig_iceMelter } from './testRig_iceMelter'
import { createTestRig_emO2 } from './testRig_emO2'
import { createTestRig_leakO2 } from './testRig_leakO2'

export const createTestRig = () => {
  let ctx = scene.getContext()
  monsters.killAll()
  asteroids.killAll()
  machines.killAll()
  cargoes.killAll()
  // stacks.killAll()
  blueprints.killAll()
  jobs.killAll()

  tileMapShip.kill(ctx.mapShip)
  ctx.mapShip = tileMapShip.createTileMapShip()

  // Faster testing
  uiSpeedBar.setSpeed(8)

  let x = 15
  let y = 15
  // createTestRig_sleep(x, y)
  // createTestRig_water(x, y)
  // createTestRig_food(x, y)

  let testRigs = [
    createTestRig_mineAsteroid,
    createTestRig_emO2,
    createTestRig_leakO2,
    createTestRig_water,
    createTestRig_food,
    createTestRig_sleep,
    createTestRig_iceMelter,
  ]
  let num = Math.abs(settings.get().testRigNum % testRigs.length)
  testRigs[num](x, y)
}

export const createNextTestRig = () => {
  settings.update({ testRigNum: settings.get().testRigNum + 1 })
  createTestRig()
}
export const createPrevTestRig = () => {
  settings.update({ testRigNum: settings.get().testRigNum - 1 })
  createTestRig()
}
